import React from "react";
import "../css/about.scss";

function About() {
  return (
    <main className="layout--template" id="main_content">
      <div
        id="about-tugglefield"
        className="shopify-section section--page"
      >
        <div className="template-page--root">
          <div className="template-page--wrapper">
            <h1 className="template-page--heading">How We Choose</h1>
            <div data-item="rte-content">
              <div style={{ textAlign: "left" }}>
                <img
                  style={{ float: "none" }}
                  alt="Tugglefield tea buyers evaluating loose-leaf tea"
                  src="/main/a1.jpg"
                />
              </div>
              <p>
                At Tugglefield, we do not choose teas and coffees by habit. We
                taste throughout the year, looking for ingredients with a clear
                sense of place and a cup worth returning to.
              </p>
              <p>
                We work with knowledgeable growers, importers, and roasters who
                can explain where an ingredient comes from, how it was handled,
                and why it tastes the way it does. Traceability and thoughtful
                production matter as much to us as aroma and flavor.
              </p>
              <p>
                Some discoveries begin with a harvest sample; others start with
                a conversation across the tasting table. Whatever the route, a
                product earns its place only when it offers something distinct
                and can be sourced with consistency and care.
              </p>
              <p>
                During our cupping sessions, we evaluate dry aroma, infused
                leaves, flavor, texture, and finish. The standouts are tested
                again with practical home-brewing methods before we write clear
                steeping guidance and share them with our customers.
              </p>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default About;
